export function getClearLocationToChangeToReducer(state, action) {
	return {
		...state,
		locationToChangeTo: null,
	};
}
